import { SpotType } from '@spiaggeit/spit-core'
import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { Surface } from '@/components/Surface'

import { mappedSpotTypes } from '../../../utils/constants'

import { SectorCardQuantityController } from './SectorCardQuantityController'

interface Props {
  imageUrl: string | null
  sectorName: string
  spotType: SpotType
  availableQuantity: number
  selectedQuanitity: number
  onAdd: () => void
  onRemove: () => void
}

export const SectorCard = (props: Props) => {
  const { t } = useTranslation()
  const { icon: Icon, label } = mappedSpotTypes[props.spotType]

  const title = t('a11y.sectorCardTitle', {
    itemName: t(label),
    sectorName: props.sectorName,
  })

  const titleId = useId()

  return (
    <Surface aria-labelledBy={titleId} as="article">
      <h2 className="sr-only" id={titleId}>
        {title}
      </h2>

      {props.imageUrl ? (
        <img
          alt=""
          className="h-[136px] w-full object-cover"
          src={props.imageUrl}
        />
      ) : null}

      <div className="p-4">
        <div className="mb-1 overflow-hidden text-ellipsis text-nowrap font-bold">
          {props.sectorName}
        </div>

        <div className="flex justify-between gap-4">
          <div className="flex min-w-0 items-center gap-2">
            <Icon aria-hidden="true" className="size-6 shrink-0" />

            <div className="overflow-hidden text-ellipsis text-nowrap">
              {t(label)}
            </div>
          </div>

          <SectorCardQuantityController
            availableQuantity={props.availableQuantity}
            onAdd={props.onAdd}
            onRemove={props.onRemove}
            selectedQuantity={props.selectedQuanitity}
          />
        </div>
      </div>
    </Surface>
  )
}
